import { Component } from '@angular/core'; 

@Component({
  selector: 'fuel-report',
  templateUrl: './fuel.component.html',  
}) 
  export class FuelReportComponent { 
  ngOnInit(){ 
  
  } 
}
 


// WEBPACK FOOTER //
// ./src/app/reports/fuel/fuel.component.ts